/** @format */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import adescomStyle from 'assets/jss/adescom/adescomStyle';
import compose from 'recompose/compose';
import GridContainer from '../../components/Grid/GridContainer';
import GridItem from '../../components/Grid/GridItem';
import I18n from '../../components/Translate/I18n';
import { FormGeneralHelper } from '../../helpers/FormGeneral';
import LimitAmount from 'components/Adescom/SimpleSelectRest';
import ActionButton from '../../components/Buttons/CustomTextButton';
import AlertInfo from '../../components/Info/AlertInfo';
import { featuresActions, featuresConstans } from '../../modules/features/actions';
import SuccessInfo from '../../components/Info/SuccessInfo';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { PlkStatusMap } from '../../helpers/iccidStatus';
import { Auth } from '../../modules/auth/Auth';
import { AlertDialog } from '../lib/dialog/AlertDialog';

const statusChangeList = { 'hydra:member': null };

class ChangeStatus extends PureComponent {
    constructor(props, context) {
        super(props, context);

        this.state = {
            entity: {
                newStatus: null,
            },
            entityStatus: {
                newStatus: null,
            },
            saveButton: false,
            alert: null,
        };

        const mvnoStatus = this.props.simCard.mvnoStatus;
        let newStatus = [];

        if (Auth.isExpertMode()) {
            newStatus = [
                { id: PlkStatusMap.ACTIVE, mainname: 'pools:em.active' },
                { id: PlkStatusMap.CANCELLED, mainname: 'pools:em.cancelled' },
                { id: PlkStatusMap.BLOCK_50, mainname: 'pools:em.restricted' },
                { id: PlkStatusMap.BLOCK_98, mainname: 'pools:em.block_98' },
                { id: PlkStatusMap.BLOCK_99, mainname: 'pools:em.block_99' },
            ];
        } else {
            if (mvnoStatus !== PlkStatusMap.ACTIVE) {
                newStatus.push({ id: PlkStatusMap.ACTIVE, mainname: 'pools:state.active' });
            }

            if (mvnoStatus === PlkStatusMap.ACTIVE) {
                newStatus.push({ id: PlkStatusMap.BLOCK_98, mainname: 'pools:state.block_98' });
                newStatus.push({ id: PlkStatusMap.BLOCK_99, mainname: 'pools:state.block_99' });
            } else {
                if (mvnoStatus !== PlkStatusMap.ACTIVE && mvnoStatus !== PlkStatusMap.BLOCK_99) {
                    newStatus.push({ id: PlkStatusMap.BLOCK_99, mainname: 'pools:state.block_99' });
                }
                if (mvnoStatus !== PlkStatusMap.ACTIVE && mvnoStatus !== PlkStatusMap.BLOCK_98) {
                    newStatus.push({ id: PlkStatusMap.BLOCK_98, mainname: 'pools:state.block_98' });
                }
            }
        }
        statusChangeList['hydra:member'] = newStatus;
    }

    cancelActivate = () => {
        this.setState({ alert: null });
    };

    actionChangeStatus = () => {
        this.setState({
            alert: (
                <AlertDialog
                    open={!this.state.alert}
                    titleDialog="simcard:s.change_status"
                    displayMessage="simcard:s.confirm_change_status"
                    closeCallback={this.cancelActivate}
                    confirmCallback={this.activateCallApi}
                />
            ),
        });
    };

    activateCallApi = () => {
        const { dispatch, simCard } = this.props;
        const params = {
            id: simCard.id,
            newStatus: this.state.entity.newStatus,
            changeMvnoStatus: true,
        };
        this.cancelActivate();
        dispatch(
            featuresActions.put(
                FormGeneralHelper.getByUri(FormGeneralHelper.getPath('/operation_on_sim_cards/' + simCard.id)),
                params,
                featuresConstans.FEATURES_POST,
                () => {
                    this.setState({
                        alert: (
                            <SuccessInfo
                                onConfirm={() => {
                                    this.cancelActivate();
                                    this.props.refreshPage();
                                }}
                                confirmBtnText="general:common.ok"
                                content="simcard:s.change_request_send"
                            />
                        ),
                    });
                },
                { propagateDataToCallback: true }
            )
        );
    };

    selectFunc = (e, stateName, require) => {
        const value = e.target.value;
        this.setState(
            (prevState) => ({
                entity: {
                    ...prevState.entity,
                    [stateName]: value,
                },
                entityStatus: {
                    ...prevState.entityStatus,
                    [stateName]: null,
                },
            }),
            () => {
                this.setState({ saveButton: true });
            }
        );
    };

    render() {
        const { entity, saveButton, alert } = this.state;

        return (
            <GridContainer>
                <GridItem xs={12}>
                    <I18n trans="simcard:s.change_status" />
                </GridItem>
                <GridItem xs={12} style={{ marginBottom: '10px' }}>
                    <LimitAmount
                        callback={this.selectFunc}
                        restElements={statusChangeList}
                        stateName="newStatus"
                        idState="newStatus"
                        idSelected={entity.newStatus}
                        propKey="id"
                        required={false}
                        propValue="mainname"
                        emptyLabel="general:common.empty_label"
                        label="simcard:s.choose_new_sim_card_status"
                    />
                </GridItem>
                {saveButton && (
                    <GridItem xs={12}>
                        <ActionButton callback={this.actionChangeStatus} callbackParam={{}} label="simcard:s.activate_new_status" size="sm" />
                        {alert}
                    </GridItem>
                )}
            </GridContainer>
        );
    }
}

ChangeStatus.propTypes = {
    classes: PropTypes.object.isRequired,
};
const mapStateToProps = (state) => {
    return {
        ...state,
    };
};
const enhance = compose(connect(mapStateToProps), withStyles(adescomStyle));
const Enhance = enhance(ChangeStatus);
export default Enhance;
